import React from "react";
import "../css/notFound.css";
import { useNavigate } from "react-router-dom"; // if using react-router

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1>404</h1>
        <h2>Oops! Nothing Found</h2>
        <p>The page or resource you’re looking for doesn’t exist.</p>
        <button className="primary-btn" onClick={() => navigate("/")}>
          Go Back Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;

